import { ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { AppChartsService } from './app-charts.service';
var AppChartsComponent = (function () {
    function AppChartsComponent(commonService, apiService, route, router, el) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.el = el;
        //前后测报告图表Theme配色
        this.surveyThemeColor = ['#BABDD0', '#7297E6'];
        // 前后测报告图表Theme
        this.surveyTheme = {
            // 基础样式
            base: {
                //居中显示
                center: ['50%', '50%'],
                // 缩放
                radius: window.screen.width > 320 ? 80 : 70,
                //labelStyle
                name: {
                    textStyle: {
                        color: '#4A4A4A',
                        fontSize: 10,
                        backgroundColor: 'rgba(0,0,0,0)',
                        padding: [0, 0]
                    },
                    formatter: function (text) {
                        if (text.length > 7) {
                            text = text.replace(/\S{7}/g, function (match) {
                                return match + '\n';
                            });
                        }
                        return text;
                    }
                },
                //坐标线Style
                axisLine: {
                    show: false,
                    lineStyle: {}
                },
                //分割数量
                splitNumber: 6,
                //背景Style
                splitArea: {
                    show: true,
                    areaStyle: {
                        color: ["#fff"]
                    }
                },
                // 线框样式
                splitLine: {
                    show: true,
                    lineStyle: {
                        width: 1,
                        color: '#e8e8e8'
                    }
                },
            },
            //indicator坐标数值Style
            indicatorAxisLabel: {
                show: true,
                fontSize: 10,
                color: '#999',
                showMaxLabel: true,
                showMinLabel: true,
                z: 10
            },
            series: {
                //symbolStyle
                symbol: "none",
                //itemStyle
                seriesDataStyle: []
            }
        };
    }
    AppChartsComponent.prototype.ngOnInit = function () {
        this.appChartsService = new AppChartsService();
        this.max = this.max ? this.max : 24;
        // 根据传入的主题配置图表主题
        this.chartsTheme = {
            "survey": this.surveyTheme
        }[this.theme] || this.surveyTheme;
        // 配置颜色
        this.setThemeColor(this.chartsData);
        if (this.isCamp) {
            this.surveyTheme.base.radius = window.screen.width > 320 ? 95 : 80;
            this.surveyTheme.base.splitLine['lineStyle']['type'] = 'dotted';
            this.surveyTheme.base.splitLine['lineStyle']['color'] = '#b8b8b8';
            this.surveyTheme.base.axisLine.show = true;
            this.surveyTheme.base.axisLine['lineStyle']['type'] = 'dotted';
            this.surveyTheme.series.symbol = 'circle';
        }
        // 根据主题设置配置
        this.chartsOpt = this.appChartsService.setChartsAttribute(this.chartsTheme, this.chartsType, this.chartsData, this.max);
    };
    AppChartsComponent.prototype.ngAfterViewInit = function () {
        this.appChartsService.chartsInit(this.chartsOpt, this.el.nativeElement.querySelector('#' + this.chartsType + 'Charts'));
    };
    // 配置颜色
    AppChartsComponent.prototype.setThemeColor = function (data) {
        var seriesDataStyleSimple;
        if (data.length > 1) {
            seriesDataStyleSimple = [];
            for (var i = 0, len = data.length; i < len; i += 1) {
                seriesDataStyleSimple[i] = {};
                if (this.isCamp) {
                    seriesDataStyleSimple[i]["color"] = this.surveyThemeColor[i];
                }
                seriesDataStyleSimple[i]["areaStyle"] = {};
                seriesDataStyleSimple[i]["lineStyle"] = {};
                seriesDataStyleSimple[i]["areaStyle"]["type"] = 'default';
                seriesDataStyleSimple[i]["areaStyle"]["color"] = this.surveyThemeColor[i];
                seriesDataStyleSimple[i]["areaStyle"]["opacity"] = 0.1;
                seriesDataStyleSimple[i]["lineStyle"]["color"] = 2;
                seriesDataStyleSimple[i]["lineStyle"]["color"] = this.surveyThemeColor[i];
                this.surveyTheme.series.seriesDataStyle = seriesDataStyleSimple;
            }
        }
        else {
            seriesDataStyleSimple = {};
            if (this.isCamp) {
                seriesDataStyleSimple["color"] = this.surveyThemeColor[1];
            }
            seriesDataStyleSimple["areaStyle"] = {};
            seriesDataStyleSimple["lineStyle"] = {};
            seriesDataStyleSimple["areaStyle"]["type"] = 'default';
            seriesDataStyleSimple["areaStyle"]["color"] = this.surveyThemeColor[1];
            seriesDataStyleSimple["areaStyle"]["opacity"] = 0.1;
            seriesDataStyleSimple["lineStyle"]["color"] = 2;
            seriesDataStyleSimple["lineStyle"]["color"] = this.surveyThemeColor[1];
            this.surveyTheme.series.seriesDataStyle.push(seriesDataStyleSimple);
        }
    };
    return AppChartsComponent;
}());
export { AppChartsComponent };



// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.component.ts.pre-build-optimizer.js